import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isConfirmed: false,
  sonar: {
    projectName: '',
    projectPassword: '',
  },
  scout: {
    projectName: '',
    projectPassword: '',
  },
  resonance: {
    projectName: '',
    projectPassword: '',
    vision: '',
  },
  genie: {
    projectName: '',
    projectPassword: '',
  },
  id8: {
    projectName: '',
    projectPassword: '',
  },
  activ8: {
    projectName: '',
    projectPassword: '',
  },
};

const consumerSlice = createSlice({
  name: 'consumer',
  initialState: initialState,
  reducers: {
    resetConsumerData: () => initialState,
    changeConfirmed: (state, action) => {
      state.isConfirmed = action.payload;
    },
    changeSonarConfirmed: (state, action) => {
      state.isConfirmed = action.payload.confirmed;
      state.sonar.projectName = action.payload.projectName;
      state.sonar.projectPassword = action.payload.projectPassword;
    },
    changeScoutConfirmed: (state, action) => {
      state.isConfirmed = action.payload.confirmed;
      state.scout.projectName = action.payload.projectName;
      state.scout.projectPassword = action.payload.projectPassword;
    },
    changeGenieConfirmed: (state, action) => {
      state.isConfirmed = action.payload.confirmed;
      state.genie.projectName = action.payload.projectName;
      state.genie.projectPassword = action.payload.projectPassword;
    },
    changeId8Confirmed: (state, action) => {
      state.isConfirmed = action.payload.confirmed;
      state.id8.projectName = action.payload.projectName;
      state.id8.projectPassword = action.payload.projectPassword;
    },
    changeResonanceConfirmed: (state, action) => {
      state.isConfirmed = action.payload.confirmed;
      state.resonance.projectName = action.payload.projectName;
      state.resonance.projectPassword = action.payload.projectPassword;
      state.resonance.vision = action.payload.vision;
    },
    changeActiv8Confirmed: (state, action) => {
      state.isConfirmed = action.payload.confirmed;
      state.activ8.projectName = action.payload.projectName;
      state.activ8.projectPassword = action.payload.projectPassword;
    },
  },
});

export const {
  resetConsumerData,
  changeConfirmed,
  changeSonarConfirmed,
  changeScoutConfirmed,
  changeResonanceConfirmed,
  changeGenieConfirmed,
  changeId8Confirmed,
} = consumerSlice.actions;

export default consumerSlice.reducer;
